// import apiFetch from '../apiFetch'
export default function (notificationId, token) {
  return {} // apiFetch({endPoint: `notification/${notificationId}/read`, method: 'PUT', body: null, token: token})
}
